import { ColumnConfig, ColumnDataType } from '@aurora';

export const engineModelColumnsConfig: ColumnConfig[] = [
    {
        type       : ColumnDataType.STRING,
        field      : 'name',
        sort       : 'name',
        translation: 'Name',
        isUnaccent : true,
    },
];
